import React from 'react';
import { Draggable } from "react-beautiful-dnd";
import ColumnHeader from './ColumnHeader';
import SGCards from '../Card/Cards';

const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});


const Column = (props) => {
    const { columnId, scoutGroupId, index } = props;
    return <Draggable key={columnId} draggableId={columnId} index={index}>
        {(provided) => (
            <div className={`kanban-column-wrap col col${index + 1}`}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={getItemStyle(provided.draggableProps.style)}
            >
                <div className="kanban-column-bg">
                    <ColumnHeader scoutGroupId={scoutGroupId} />
                    <SGCards scoutGroupId={scoutGroupId} />
                    {/* {isHaveCrew ? <div className="kanban-column">
                        <ColumnHeader crewId={crewId} />
                        <EGCards crewId={crewId} />
                    </div>
                        : isAllowCreate && <div className="kanban-column-add">
                            <span onClick={() => setOpenModal(!openModal)}><i className="fa fa-plus-circle" />Add crew</span>
                        </div>} */}
                </div>
            </div>
        )}
    </Draggable>
}

export default Column